import React, {Component} from "react";
import FJLocalStore from "../../../store/FJLocalStore";
import FJToolbarButton from "./FJToolbarButton";
import FJDropDown from "fj-components/FJDropDown"
import Style from "./FJFade.module.less";
import FJSliderInput from "../../../common/component/slider/FJSliderInput";

class FJFade extends Component {
  constructor(props) {
    super(props);
    this.fadeInSlider = React.createRef();
    this.fadeOutSlider = React.createRef();
  }

  componentDidMount() {
    // 初始化输入框数据
    this._updateFade(this.fadeInSlider, this.props.fadeIn);
    this._updateFade(this.fadeOutSlider, this.props.fadeOut);
  };

  componentDidUpdate(prevProps, prevState) {
    if (prevProps.fadeIn !== this.props.fadeIn) {
      this._updateFade(this.fadeInSlider, this.props.fadeIn);
    }
    if (prevProps.fadeOut !== this.props.fadeOut) {
      this._updateFade(this.fadeOutSlider, this.props.fadeOut);
    }
  }

  _updateFade = (slider, value) => {
    slider.current.updateSlider(value);
  }

  _fadeInDataChange = (data) => {
    this.props.fadeInDataChange(data.type, parseFloat(data.value));
  }

  _fadeOutDataChange = (data) => {
    this.props.fadeOutDataChange(data.type, parseFloat(data.value));
  }

  _triggerClick = (e) => {
    try {

      // 点击的如果是文字需要往上找到事件按钮并取消焦点
      e.target.blur();
      e.target.parentNode.blur();
      e.target.parentNode.parentNode.blur();
    } catch (err) {
      console.log(err);
    }
  };

  render() {
    let {disabled} = this.props;
    return (
      <FJDropDown overlay={
        <div className={Style.popup_panel}>
          <div className={Style.fade_slider}>
            <FJSliderInput ref={this.fadeInSlider}
                           sliderID='fadeInSlider'
                           name={FJLocalStore._('fade-in')}
                           min={0}
                           max={5}
                           showSecond
                           callback={this._fadeInDataChange}
                           step={0.1}/>
          </div>
          <div className={Style.fade_slider}>
            <FJSliderInput ref={this.fadeOutSlider}
                           sliderID='fadeOutSlider'
                           name={FJLocalStore._('fade-out')}
                           min={0}
                           max={5}
                           showSecond
                           callback={this._fadeOutDataChange}
                           step={0.1}/>
          </div>
        </div>
      }
                  hasArrow={true}
                  triggerClick={this._triggerClick}
                  canTriggerActive>
        <FJToolbarButton text={FJLocalStore._('fade')}
                         disabled={disabled}/>
      </FJDropDown>
    )
  }
}

export default FJFade;
